videoPlayerControls.controller('videoPlayerControlsCtrl', [
    '$rootScope',
    '$scope',
    '$window',
    '$timeout',
    '$interval',
    'logService',
    'socketService',
    'attendeeService',
    'contentService',
    'meetingService',
    'localizationService',
    function (
        $rootScope,
        $scope,
        $window,
        $timeout,
        $interval,
        logService,
        socketService,
        attendeeService,
        contentService,
        meetingService,
        localizationService
    ) {
        var self = this;

        self.attendantId = 0;
        self.idle = false;
        self.idleTimeout = null;
        self.isVideoLoaded = false;
        self.controlHovered = false;

        self.startIdleTimeout = startIdleTimeout;
        self.stopIdleTimeout = stopIdleTimeout;
        self.resetIdleTimeout = resetIdleTimeout;
        self.startControlHover = startControlHover;
        self.stopControlHover = stopControlHover;
        self.renderVideoScrubber = renderVideoScrubber;
        self.beginPlaybackTimerUpdate = beginPlaybackTimerUpdate;
        self.togglePlayback = togglePlayback;
        self.stop = stop;
        self.seek = seek;
        self.translateTimeString = translateTimeString;
        self.onSliderChangeEnd = onSliderChangeEnd;
        self.disablePauseButton = false;
        self.leftPad = leftPad;
        self.initFromContentService = initFromContentService;
        self.cleanup = cleanup;

        self.getTogglePlaybackTooltip = getTogglePlaybackTooltip;

        //file seek vars
        self.currentTime = 0;
        self.totalTime = 0;
        self.progressInterval = null;
        self.playbackState = '';

        self.options = {
            floor: 0,
            ceil: self.totalTime, //defaults to rz-slider-model
            step: 1,
            translate: self.translateTimeString,
            hidePointerLabels: false,
            hideLimitLabels: false,
            onStart: function (id, newValue) {
                $interval.cancel(self.progressInterval);
                self.progressInterval = null;
            },
            onChange: null,
            onEnd: onSliderChangeEnd
        };

        $scope.contentService = contentService;

        //TODO: Change anonymous functions to named functions for readability

        // Called by the content library modal
        $scope.$on('start-video', function (eventName, eventVideoPath) {
            logService.log('Starting video: ' + eventVideoPath);
            self.play(eventVideoPath);
        });

        $scope.$on('video-playing', function (eventName, attendantId, playStatus, videoPaused) {
            if (meetingService.isWebinar()) {
                if (!attendeeService.getIsPresenter()) return;
            } else {
                if (attendantId !== self.attendantId) {
                    return;
                }
            }

            self.initFromContentService();

            digest();
        });

        $scope.$on('video-stopped', function (eventName) {
            self.cleanup();
        });

        $scope.$on('seek-video-success', function (ev, data) {
            logService.log('here - seek-video-success ', data);
            self.currentTime = Math.floor(data.time / 1000);
            digest();
        });

        $scope.$on('video-playback-toggled', onVideoPlaybackToggled);
        $scope.$on('enable-pause-button', onEnablePauseButton);

        $scope.$on('content-status', onContentInit);

        //need this little hack to have the slider render correctly
        $scope.$on('fs-connection-complete', function () {
            setTimeout(function () {
                self.renderVideoScrubber();
            }, 2000);
        });

        $scope.$on('content-cleanup', cleanup);

        init();

        ////////////////////////

        function leftPad(str, character, length) {
            var paddedString = str.toString();
            while (paddedString.length < length) {
                paddedString = character + paddedString;
            }
            return paddedString;
        }

        function translateTimeString(value) {
            var hours = Math.floor(value / 3600);
            var minutes = Math.floor((value - hours * 3600) / 60);
            var seconds = Math.floor(value % 60);
            return (hours > 0 ? hours + ':' : '') + leftPad(minutes, '0', 2) + ':' + leftPad(seconds, '0', 2);
        }

        function onSliderChangeEnd(id, newValue) {
            self.seek(newValue);
            if (self.playbackState !== 'pause') {
                self.beginPlaybackTimerUpdate();
            }
        }

        function renderVideoScrubber() {
            $timeout(function () {
                //force render of slider control
                $scope.$broadcast('rzSliderForceRender');
            });
        }

        function beginPlaybackTimerUpdate() {
            logService.log('videoPlayerControls beginPlaybackTimerUpdate');
            if (self.progressInterval == null) {
                self.progressInterval = $interval(function () {
                    self.currentTime += 1;
                }, 1000);
            }
        }

        function init() {
            logService.log('videoPlayerControls init');
            self.attendantId = attendeeService.getAttendantId();
        }

        function togglePlayback() {
            if (self.disablePauseButton === true) {
                return;
            }

            var msgObj = {
                message: 'toggle-video',
                data: {}
            };

            socketService.send(msgObj);
            self.disablePauseButton = true;
        }

        function stop() {
            contentService.stopCurrentContent();
        }

        function seek(second) {
            if (!self.isVideoLoaded) {
                return;
            }

            var msgObj = {
                message: 'seek-video',
                data: {
                    ms: second * 1000
                }
            };

            socketService.send(msgObj);
        }

        function resetIdleTimeout() {
            self.stopIdleTimeout();
            self.startIdleTimeout();
        }

        function stopIdleTimeout() {
            if (!self.isVideoLoaded) {
                return;
            }

            //logService.log('Stopping idle timeout');

            if (self.idleTimeout) {
                $timeout.cancel(self.idleTimeout);
                self.idleTimeout = null;
            }
            self.idle = false;
        }

        function startIdleTimeout() {
            if (!self.isVideoLoaded) {
                return;
            }

            self.idleTimeout = $timeout(function () {
                self.idle = true;
            }, 3000);
        }

        function startControlHover() {
            logService.log('Starting control hover');
            self.controlHovered = true;
            self.stopIdleTimeout();
        }

        function stopControlHover() {
            logService.log('Stopping control hover');
            self.controlHovered = false;
            self.startIdleTimeout();
        }

        function onVideoPlaybackToggled() {
            self.disablePauseButton = false;

            var isPlaying = self.playbackState === 'playing';

            if (isPlaying) {
                $interval.cancel(self.progressInterval);
                self.progressInterval = null;
                self.playbackState = 'pause';
            } else {
                self.beginPlaybackTimerUpdate();
                self.playbackState = 'playing';
            }

            digest();
        }

        function onEnablePauseButton() {
            self.disablePauseButton = false;
            digest();
        }

        function digest() {
            if (!$scope.$$phase) {
                $scope.$digest();
            }
        }

        function onContentInit(e, data) {
            //logService.log("onContentInit", data);
            if (data.type == 'video') {
                self.initFromContentService();
                digest();
            }
        }

        function initFromContentService() {
            var contentObj = contentService.getCurrentContentObject();
            var playStatus = contentObj.playStatus;
            var videoPaused = contentObj.paused;

            logService.log('initFromContentService contentObj', contentObj);

            if (meetingService.isWebinar()) {
                if (!attendeeService.getIsPresenter()) return;
            } else {
                if (contentObj.ownerID !== self.attendantId) {
                    return;
                }
            }

            logService.log('initFromContentService videoPaused', videoPaused);
            logService.log('initFromContentService playStatus', playStatus);
            logService.log('initFromContentService contentObj', contentObj);

            if (contentObj.state != 'stopped' && contentObj.type == 'video') {
                if (playStatus && playStatus.indexOf('+OK') !== -1) {
                    logService.log('video playStatus received: ' + playStatus);

                    //if (!videoPaused) {
                    //Gives us "current / total"
                    var currentOverTotal = playStatus.split(' ')[1];
                    self.currentTime = Math.floor(currentOverTotal.split('/')[0] / 1000000);
                    self.totalTime = Math.floor(currentOverTotal.split('/')[1] / 1000000);
                    self.options.ceil = self.totalTime;

                    logService.log('video currentTime: ', self.currentTime, ' totalTime: ', self.totalTime);

                    self.renderVideoScrubber();
                    //}
                }

                if (!videoPaused) {
                    self.playbackState = 'playing';
                    self.beginPlaybackTimerUpdate();
                } else {
                    self.playbackState = 'pause';
                }

                logService.log('Video playing');
                self.isVideoLoaded = true;
            }
        }

        function cleanup() {
            self.isVideoLoaded = false;
            self.playbackState = 'stopped';

            if (self.idleTimeout) {
                $timeout.cancel(self.idleTimeout);
                self.idleTimeout = null;
            }
            $interval.cancel(self.progressInterval);
            self.progressInterval = null;

            digest();
        }

        function getTogglePlaybackTooltip() {
            return self.playbackState === 'playing'
                ? localizationService.translate('VIDEO_SHARE.PAUSE_VIDEO')
                : localizationService.translate('VIDEO_SHARE.PLAY_VIDEO');
        }
    }
]);
